export default __webpack_public_path__ + "static/media/032-maximum.b544a731.png";